<div class="jumbotron">
  <h2>Access Denied</h2>
</div>
<div class="btn btn-info" (click)="onBackClick()" *ngIf="false">Back to Sales Optima</div>
